import axios from 'axios';
import { useQuery } from 'react-query';
import { queryKeys } from '../network/queryKeys';

const { REACT_APP_API_HOST } = process.env;

export type TeamSummary = { id: string; name: string; [key: string]: any };
export type OfficeSummary = { id: string; name: string; [key: string]: any };

// The API wraps lists as { status, data }; these hooks always cache the
// unwrapped array.
async function fetchList<T>(path: string): Promise<T[]> {
  const { data: response } = await axios.get(
    `${REACT_APP_API_HOST}/v1/${path}`,
  );
  return Array.isArray(response?.data) ? response.data : [];
}

/** The company's teams, always as an array. */
export function useTeams() {
  return useQuery(queryKeys.teams, () => fetchList<TeamSummary>('team'));
}

/** The company's offices, always as an array. */
export function useOffices() {
  return useQuery(queryKeys.offices, () => fetchList<OfficeSummary>('office'));
}
